import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Flex, Text, List, Button, Modal } from "@mantine/core";
import { IconAlertTriangleFilled } from "@tabler/icons-react";

export default function DealerWarnings({ reqData }) {
  const [warnings, setWarnings] = useState([]);
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    fetchWarnings();
  }, []);

  function fetchWarnings() {
    const req = {
      ...reqData,
    };

    axios
      .post("/ride-challenge/retrieve-warnings/", req)
      .then(({ data }) => {
        setWarnings(data.response);
      })
      .catch((err) => {
        setWarnings([]);
      });
  }

  function onClose() {
    setOpen(false);
  }

  if (!warnings.length) return null;

  return (
    <Box mt="xs">
      <Flex justify="center">
        <Button
          leftSection={<IconAlertTriangleFilled size={16} />}
          size="xs"
          variant="light"
          color="yellow"
          onClick={() => setOpen(true)}
          radius="xl"
        >
          View Warnings
        </Button>
      </Flex>
      <Modal opened={isOpen} onClose={onClose}>
        <Text mb="lg" fw={600}>
          You may proceed, but if any of the following feels unrealistic, please
          ask the customer for details.
        </Text>
        <List>
          {warnings.map((warning, i) => (
            <List.Item key={i}>{warning}</List.Item>
          ))}
        </List>
      </Modal>
    </Box>
  );
}
